import { useEffect } from "react";

import chmln from "@chamaeleonidae/chmln";
import { useFlags } from "launchdarkly-react-client-sdk";

import { useUser } from "src/contexts/user-context";

const CHAMELEON_TOKEN =
  "SzClcrwLDmIz9LsCCZ7wDMLd73WhTZTleagtQ0L1uRFmfU-1W3nvk-GyE6GJCbEd7zbq2o";

// `chmln.init` installs a `window.chmln` global. A second call refuses to run and warns.
let initialized = false;

export const Chameleon = () => {
  const { user } = useUser();
  const { appChameleonDisabled } = useFlags();

  useEffect(() => {
    if (!appChameleonDisabled && !initialized) {
      try {
        chmln.init(CHAMELEON_TOKEN, { fastUrl: "https://fast.chameleon.io/" });
        initialized = true;
      } catch (error) {
        // Non-critical third-party SDK; log only, don't send to Sentry
        console.log(error);
      }
    }
  }, [appChameleonDisabled]);

  // TODO(eric.lovett): This `biome-ignore` was part of a blanket suppression so that we could
  // turn on the rule. It is probably covering up a real bug. Please fix this or replace this
  // TODO with an explanation of why we don't want all deps listed.
  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy suppression, probably a bug
  useEffect(() => {
    if (user && !appChameleonDisabled) {
      try {
        chmln.identify(user.id, {
          uid_hash: user.chameleon_uid,
          email: user.email,
          company: {
            uid: user.organization?.id,
            country: user.personalization?.company_country,
          },
        });
      } catch (error) {
        // Non-critical third-party SDK; log only, don't send to Sentry
        console.log(error);
      }
    }
  }, [Boolean(user), appChameleonDisabled]);

  return null;
};
